exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-2fd8bbec] tbody td{\n    cursor: pointer;\n}\n.container[data-v-2fd8bbec]{\n    max-width: 100vw;\n}\n[data-v-2fd8bbec] tbody td td.non-clickable{\n    cursor: auto;\n}\n.chip-overflow[data-v-2fd8bbec] {\n    max-width: 90px;\n    display:block;\n}\n", ""]);

// exports
